module.exports = __webpack_public_path__ + "img/pause.51fab8a0.svg";